/**
 * SidebarElement — F12.H T12.H.2.
 *
 * Boczny panel (sidebar) — pionowa kolumna z dodatkowymi sekcjami lub
 * navigation. Różni się od PageAside tym że jest na całą wysokość strony,
 * nie obok formularza.
 *
 * Settings: { position?: 'left'|'right', width?: 'narrow'|'wide',
 *             collapsible?: boolean, title? }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

export const SidebarElement: LayoutElementDefinition = {
  type: 'sidebar',
  category: 'struktura',
  isContainer: true,
  label: 'Sidebar',
  icon: 'PanelLeft',
  defaultSettings: () => ({
    position: 'left',
    width: 'narrow',
    collapsible: false,
    title: '',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      position?: 'left' | 'right';
      width?: 'narrow' | 'wide';
      collapsible?: boolean;
      title?: string;
    };
    const widthClass = settings.width === 'wide' ? 'w-64' : 'w-48';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`${widthClass} h-full shrink-0 border-r border-border-primary bg-bg-secondary p-3 ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition' : ''}`}
        data-testid={`sidebar-element-${element.id}`}
        data-element-type="sidebar"
        data-position={settings.position ?? 'left'}
        data-collapsible={settings.collapsible ? 'true' : 'false'}
      >
        {settings.title && (
          <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-text-secondary">
            {settings.title}
          </h3>
        )}
        {children.length > 0 ? (
          <nav className="space-y-1">{children}</nav>
        ) : isBuilder ? (
          <p className="text-xs italic text-text-muted">(sidebar pusty — przeciągnij elementy)</p>
        ) : null}
      </div>
    );
  },
};
